import { ConfigProvider } from 'antd';
import UserContext from 'src/admin/views/UserContext';
import { swrConfig } from 'src/lib/swr';
import { themeConfig } from 'src/lib/theme';
import { MainRouter } from 'src/router/router';
import { SWRConfig } from 'swr';

export function App() {
  return (
    <ConfigProvider theme={themeConfig}>
      <SWRConfig value={swrConfig}>
        <UserContext>
          <MainRouter />
        </UserContext>
      </SWRConfig>
    </ConfigProvider>
  );
}
